import { RoutePaths } from './constants';

export const getRoute = (route: RoutePaths, id: string | number) => {
  return route.replace(`:id`, id.toString());
};
export const getRoute1 = (
  route: string,
  id: string | number,
  query?: Record<string, string | number>
) => {
  let path = route.replace(":id", id.toString());

  if (query) {
    path +=
      "?" +
      new URLSearchParams(
        Object.entries(query).reduce(
          (acc, [k, v]) => ({ ...acc, [k]: String(v) }),
          {}
        )
      ).toString();
  }

  return path;
};
export const getPermission = (user: any, key: string) => {
  return user?.rolePermission?.find((p: any) => p.menuKey === key)?.permissions;
};
export const reload = () => {
  window.location.reload();
};
